/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpParams,
  HttpResponse,
  HttpEvent,
  HttpParameterCodec,
  HttpContext
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { HeadcountApprovalPositionRequestsPositionRequestModel } from '@coin/shared/core/util-models';
import { HeadcountOverviewAnalyticsReportModel } from '@coin/shared/core/util-models';
import { HeadcountOverviewDepartmentsDepartmentAdjustmentsModel } from '@coin/shared/core/util-models';
import { HeadcountOverviewDepartmentsDepartmentBreadcrumbItemModel } from '@coin/shared/core/util-models';
import { HeadcountOverviewDepartmentsUpdateDepartmentAdjustmentsModel } from '@coin/shared/core/util-models';
import { HeadcountOverviewDetailedTeamMembersTeamMemberDetailsModel } from '@coin/shared/core/util-models';
import { HeadcountOverviewDetailedTeamMembersUpdateTeamMemberAvailabilityModel } from '@coin/shared/core/util-models';
import { HeadcountOverviewMatchingCreateManualPositionRequestMatchingModel } from '@coin/shared/core/util-models';
import { HeadcountOverviewMatchingPositionRequestMatchingModel } from '@coin/shared/core/util-models';
import { HeadcountOverviewMatchingResetPositionRequestMatchingModel } from '@coin/shared/core/util-models';
import { HeadcountOverviewPositionRequestsUpdatePositionRequestFinancialDataModel } from '@coin/shared/core/util-models';
import { HeadcountOverviewTeamMemberAvailabilityPeriodsCreateTeamMemberAvailabilityPeriodModel } from '@coin/shared/core/util-models';
import { SharedFieldValuesModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfHeadcountOverviewDepartmentsDepartmentAdjustmentsModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfHeadcountOverviewDepartmentsDepartmentModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfHeadcountOverviewMatchingPositionRequestMatchingEmployeeModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfHeadcountOverviewTeamMemberAvailabilityAggregationsTeamMemberAvailabilityAggregationModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfHeadcountOverviewTeamMemberAvailabilityPeriodsTeamMemberAvailabilityPeriodModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfHeadcountOverviewTeamMembersTeamMemberModel } from '@coin/shared/core/util-models';
import { SharedPageModelOfSystemString } from '@coin/shared/core/util-models';
import { TransactionStatusOfExportStatusMetadata } from '@coin/shared/core/util-models';

import { CustomHttpParameterCodec } from '../encoder';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';

export interface HeadcountOverviewServiceAcceptMatchingPositionRequestMatchingRequestParams {
  employeeId?: string;
  positionRequestId?: string;
}

export interface HeadcountOverviewServiceCreateManualMatchingPositionRequestMatchingRequestParams {
  headcountOverviewMatchingCreateManualPositionRequestMatchingModel?: HeadcountOverviewMatchingCreateManualPositionRequestMatchingModel;
}

export interface HeadcountOverviewServiceCreateTeamMemberAvailabilityPeriodsRequestParams {
  teamMemberId: string;
  disableElevatedPermissions?: boolean;
  headcountOverviewTeamMemberAvailabilityPeriodsCreateTeamMemberAvailabilityPeriodModel?: HeadcountOverviewTeamMemberAvailabilityPeriodsCreateTeamMemberAvailabilityPeriodModel;
}

export interface HeadcountOverviewServiceDeleteDepartmentAdjustmentDepartmentAdjustmentsRequestParams {
  /** The department of which the adjustments should be returned of. */
  department: string;
  /** The cost center of which the adjustments should be returned of. */
  costCenter?: string;
  /** The legal entity of which the adjustments should be returned of. */
  areCode?: string;
  /** The depth structure of which the adjustments should be returned of. */
  depthStructure?: string;
  disableElevatedPermissions?: boolean;
}

export interface HeadcountOverviewServiceDeleteTeamMemberAvailabilityPeriodTeamMemberAvailabilityPeriodsRequestParams {
  teamMemberId: string;
  id: string;
  disableElevatedPermissions?: boolean;
}

export interface HeadcountOverviewServiceExportDepartmentAnalyticsReportExportRequestParams {
  /** The organisation of which a report should be returned of. */
  department: string;
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  filename?: string;
  showEmployees?: boolean;
  showNewRequests?: boolean;
  showAdjustments?: boolean;
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  disableElevatedPermissions?: boolean;
}

export interface HeadcountOverviewServiceExportListViewTeamMembersExportRequestParams {
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  /** The organisation of which the team members should be returned of. */
  departments?: Array<string>;
  /** The organisation which should be excluded from the returned list. */
  departmentsExcluding?: Array<string>;
  showEmployees?: boolean;
  showNewRequests?: boolean;
  showAdjustments?: boolean;
  priorityEmployeeId?: string;
  priorityPositionRequestId?: string;
  filename?: string;
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  disableElevatedPermissions?: boolean;
}

export interface HeadcountOverviewServiceExportTeamAnalyticsReportExportRequestParams {
  /** The organisation of which a report should be returned of. */
  department: string;
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  filename?: string;
  showEmployees?: boolean;
  showNewRequests?: boolean;
  showAdjustments?: boolean;
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  disableElevatedPermissions?: boolean;
}

export interface HeadcountOverviewServiceGetAvailableEmployeesForMatchingPositionRequestMatchingRequestParams {
  positionRequestId: string;
  /** Search term to search an employee by firstname, lastname, or GID */
  searchTerm?: string;
  page?: number;
  size?: number;
}

export interface HeadcountOverviewServiceGetDepartmentAdjustmentDepartmentAdjustmentsRequestParams {
  /** The department of which the adjustments should be returned of. */
  department: string;
  /** The year and month to first include adjustments for. */
  startDate: string;
  /** The year and month to no longer include adjustments for. */
  endDate: string;
  /** The cost center of which the adjustments should be returned of. */
  costCenter?: string;
  /** The legal entity of which the adjustments should be returned of. */
  areCode?: string;
  /** The depth structure of which the adjustments should be returned of. */
  depthStructure?: string;
  disableElevatedPermissions?: boolean;
}

export interface HeadcountOverviewServiceGetDepartmentAdjustmentsDepartmentAdjustmentsRequestParams {
  /** The year and month to first include adjustments for. */
  startDate: string;
  /** The year and month to no longer include adjustments for. */
  endDate: string;
  /** The department of which the adjustments should be returned of. */
  departments?: Array<string>;
  /** The organisation which should be excluded from the returned list. */
  departmentsExcluding?: Array<string>;
  businessArea?: Array<string>;
  /** If values should be shown as FTE or HC */
  headcountDisplayType?: 'Headcount' | 'FullTimeEquivalent';
  /** The cost center of which the adjustments should be returned of. */
  costCenter?: Array<string>;
  /** The legal entity of which the adjustments should be returned of. */
  areCode?: Array<string>;
  /** The depth structure of which the adjustments should be returned of. */
  depthStructure?: Array<string>;
  page?: number;
  size?: number;
  disableElevatedPermissions?: boolean;
}

export interface HeadcountOverviewServiceGetDepartmentBreadcrumbDepartmentBreadcrumbRequestParams {
  orgCode: string;
}

export interface HeadcountOverviewServiceGetDepartmentReportAnalyticsFieldValuesRequestParams {
  field:
    | 'AreCode'
    | 'OrgCode'
    | 'BusinessArea'
    | 'CountryTitle'
    | 'Region'
    | 'Location'
    | 'Gid'
    | 'CostCenter'
    | 'DepthStructure'
    | 'DepthStructureText'
    | 'ContractStatus'
    | 'WorkforceType';
  /** The organisation of which field values should be returned of. */
  department: string;
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  search?: string;
  showEmployees?: boolean;
  showNewRequests?: boolean;
  showAdjustments?: boolean;
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  page?: number;
  size?: number;
  disableElevatedPermissions?: boolean;
}

export interface HeadcountOverviewServiceGetDepartmentReportAnalyticsReportsRequestParams {
  /** The organisation of which a report should be returned of. */
  department: string;
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  headcountDisplayType: 'Headcount' | 'FullTimeEquivalent';
  showEmployees?: boolean;
  showNewRequests?: boolean;
  showAdjustments?: boolean;
  changeDisplayType?: 'Absolute' | 'Percentage';
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  disableElevatedPermissions?: boolean;
}

export interface HeadcountOverviewServiceGetDetailsTeamMembersRequestParams {
  id: string;
  startDate: string;
  endDate: string;
  disableElevatedPermissions?: boolean;
}

export interface HeadcountOverviewServiceGetMatchingsForPositionRequestPositionRequestMatchingRequestParams {
  positionRequestId: string;
  /** Parameter to optionally filter by Acknowledge State */
  acknowledgeStatesFilter?: Array<'Open' | 'Accepted' | 'Rejected' | 'Irrelevant'>;
  /** Search term to search an employee by firstname, lastname, or GID */
  searchTerm?: string;
}

export interface HeadcountOverviewServiceGetTeamReportAnalyticsFieldValuesRequestParams {
  field:
    | 'AreCode'
    | 'OrgCode'
    | 'BusinessArea'
    | 'CountryTitle'
    | 'Region'
    | 'Location'
    | 'Gid'
    | 'CostCenter'
    | 'DepthStructure'
    | 'DepthStructureText'
    | 'ContractStatus'
    | 'WorkforceType';
  /** The organisation of which field values should be returned of. */
  department: string;
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  search?: string;
  showEmployees?: boolean;
  showNewRequests?: boolean;
  showAdjustments?: boolean;
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  page?: number;
  size?: number;
  disableElevatedPermissions?: boolean;
}

export interface HeadcountOverviewServiceGetTeamReportAnalyticsReportsRequestParams {
  /** The organisation of which a report should be returned of. */
  department: string;
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  headcountDisplayType: 'Headcount' | 'FullTimeEquivalent';
  showEmployees?: boolean;
  showNewRequests?: boolean;
  showAdjustments?: boolean;
  changeDisplayType?: 'Absolute' | 'Percentage';
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  disableElevatedPermissions?: boolean;
}

export interface HeadcountOverviewServiceIsReadOnlyModeUltimoPhaseRequestParams {
  disableElevatedPermissions?: boolean;
}

export interface HeadcountOverviewServicePageAnalyticsDepartmentCodesAnalyticsDepartmentCodesRequestParams {
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  /** The business-areas to query departments of. */
  businessArea?: Array<string>;
  search?: string;
  page?: number;
  size?: number;
  disableElevatedPermissions?: boolean;
}

export interface HeadcountOverviewServicePageTeamDepartmentCodesTeamDepartmentCodesRequestParams {
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  /** The business-areas to query departments of. */
  businessArea?: Array<string>;
  search?: string;
  page?: number;
  size?: number;
  disableElevatedPermissions?: boolean;
}

export interface HeadcountOverviewServicePostUltimoPhaseStartDateOverrideUltimoPhaseRequestParams {
  body?: string;
}

export interface HeadcountOverviewServiceQueryAggregatedDepartmentAvailabilitiesAvailabilityAggregationRequestParams {
  /** The organisation of which the departments should be returned of. */
  department: string;
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  headcountDisplayType: 'Headcount' | 'FullTimeEquivalent';
  showEmployees?: boolean;
  showNewRequests?: boolean;
  showAdjustments?: boolean;
  changeDisplayType?: 'Absolute' | 'Percentage';
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  page?: number;
  size?: number;
  disableElevatedPermissions?: boolean;
}

export interface HeadcountOverviewServiceQueryAggregatedTeamMemberAvailabilitiesAvailabilityAggregationRequestParams {
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  /** The organisation of which the team members should be returned of. */
  departments?: Array<string>;
  /** The organisation which should be excluded from the returned list. */
  departmentsExcluding?: Array<string>;
  showEmployees?: boolean;
  showNewRequests?: boolean;
  priorityEmployeeId?: string;
  priorityPositionRequestId?: string;
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  disableElevatedPermissions?: boolean;
}

export interface HeadcountOverviewServiceQueryBusinessAreasBusinessAreasRequestParams {
  page?: number;
  size?: number;
  disableElevatedPermissions?: boolean;
}

export interface HeadcountOverviewServiceQueryFieldValuesTeamMemberFieldValuesRequestParams {
  field:
    | 'AreCode'
    | 'OrgCode'
    | 'BusinessArea'
    | 'CountryTitle'
    | 'Region'
    | 'Location'
    | 'Gid'
    | 'CostCenter'
    | 'DepthStructure'
    | 'DepthStructureText'
    | 'ContractStatus'
    | 'WorkforceType';
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  search?: string;
  /** The organisation of which the team members should be returned of. */
  departments?: Array<string>;
  /** The department which should be excluded from the returned list. */
  departmentsExcluding?: Array<string>;
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  page?: number;
  size?: number;
  disableElevatedPermissions?: boolean;
}

export interface HeadcountOverviewServiceQueryIrrelevantAnalyticsTeamMemberRequestParams {
  /** The organisation of which a report should be returned of. */
  department: string;
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  disableElevatedPermissions?: boolean;
}

export interface HeadcountOverviewServiceQueryIrrelevantPositionRequestsAnalyticsTeamMemberRequestParams {
  /** The organisation of which a report should be returned of. */
  department: string;
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  disableElevatedPermissions?: boolean;
}

export interface HeadcountOverviewServiceQueryRelevantAnalyticsTeamMemberRequestParams {
  /** The organisation of which a report should be returned of. */
  department: string;
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  disableElevatedPermissions?: boolean;
}

export interface HeadcountOverviewServiceQueryRelevantPositionRequestsAnalyticsTeamMemberRequestParams {
  /** The organisation of which a report should be returned of. */
  department: string;
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  disableElevatedPermissions?: boolean;
}

export interface HeadcountOverviewServiceQueryTeamMemberAvailabilityPeriodsRequestParams {
  teamMemberId: string;
  startDate: string;
  endDate: string;
  page?: number;
  size?: number;
  disableElevatedPermissions?: boolean;
}

export interface HeadcountOverviewServiceQueryTeamMembersRequestParams {
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  search?: string;
  /** The department of which the team members should be returned of. */
  departments?: Array<string>;
  /** The department which should be excluded from the returned list. */
  departmentsExcluding?: Array<string>;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  disableElevatedPermissions?: boolean;
}

export interface HeadcountOverviewServiceRejectMatchingPositionRequestMatchingRequestParams {
  employeeId?: string;
  positionRequestId?: string;
}

export interface HeadcountOverviewServiceResetMatchingPositionRequestMatchingRequestParams {
  headcountOverviewMatchingResetPositionRequestMatchingModel?: HeadcountOverviewMatchingResetPositionRequestMatchingModel;
}

export interface HeadcountOverviewServiceUpdateDepartmentAdjustmentsDepartmentAdjustmentsRequestParams {
  disableElevatedPermissions?: boolean;
  headcountOverviewDepartmentsUpdateDepartmentAdjustmentsModel?: HeadcountOverviewDepartmentsUpdateDepartmentAdjustmentsModel;
}

export interface HeadcountOverviewServiceUpdateManyTeamMemberAvailabilitiesTeamMembersRequestParams {
  id: string;
  startDate: string;
  endDate: string;
  disableElevatedPermissions?: boolean;
  headcountOverviewDetailedTeamMembersUpdateTeamMemberAvailabilityModel?: Array<HeadcountOverviewDetailedTeamMembersUpdateTeamMemberAvailabilityModel>;
}

export interface HeadcountOverviewServiceUpdatePositionRequestFinancialDataOverviewPositionRequestRequestParams {
  id: string;
  headcountOverviewPositionRequestsUpdatePositionRequestFinancialDataModel?: HeadcountOverviewPositionRequestsUpdatePositionRequestFinancialDataModel;
}

/**
 * @deprecated The v1 API client is deprecated. Use the v2 client from `@coin/shared/core/data-access-v2` instead.
 */
@Injectable({
  providedIn: 'root'
})
export class HeadcountOverviewService {
  protected basePath = 'http://localhost';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();
  public encoder: HttpParameterCodec;

  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    if (configuration) {
      this.configuration = configuration;
    }
    if (typeof this.configuration.basePath !== 'string') {
      const firstBasePath = Array.isArray(basePath) ? basePath[0] : undefined;
      if (firstBasePath != undefined) {
        basePath = firstBasePath;
      }

      if (typeof basePath !== 'string') {
        basePath = this.basePath;
      }
      this.configuration.basePath = basePath;
    }
    this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
  }

  // @ts-ignore
  private addToHttpParams(httpParams: HttpParams, value: any, key?: string): HttpParams {
    if (typeof value === 'object' && value instanceof Date === false) {
      httpParams = this.addToHttpParamsRecursive(httpParams, value);
    } else {
      httpParams = this.addToHttpParamsRecursive(httpParams, value, key);
    }
    return httpParams;
  }

  private addToHttpParamsRecursive(httpParams: HttpParams, value?: any, key?: string): HttpParams {
    if (value == null) {
      return httpParams;
    }

    if (typeof value === 'object') {
      if (Array.isArray(value)) {
        (value as any[]).forEach(elem => (httpParams = this.addToHttpParamsRecursive(httpParams, elem, key)));
      } else if (value instanceof Date) {
        if (key != null) {
          httpParams = httpParams.append(key, (value as Date).toISOString().substring(0, 10));
        } else {
          throw Error('key may not be null if value is Date');
        }
      } else {
        Object.keys(value).forEach(
          k => (httpParams = this.addToHttpParamsRecursive(httpParams, value[k], key != null ? `${key}.${k}` : k))
        );
      }
    } else if (key != null) {
      httpParams = httpParams.append(key, value);
    } else {
      throw Error('key may not be null if value is not object or array');
    }
    return httpParams;
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public acceptMatchingPositionRequestMatching(
    requestParameters?: HeadcountOverviewServiceAcceptMatchingPositionRequestMatchingRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public acceptMatchingPositionRequestMatching(
    requestParameters?: HeadcountOverviewServiceAcceptMatchingPositionRequestMatchingRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public acceptMatchingPositionRequestMatching(
    requestParameters?: HeadcountOverviewServiceAcceptMatchingPositionRequestMatchingRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public acceptMatchingPositionRequestMatching(
    requestParameters?: HeadcountOverviewServiceAcceptMatchingPositionRequestMatchingRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    const positionRequestId = requestParameters?.positionRequestId;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (employeeId !== undefined && employeeId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>employeeId, 'employeeId');
    }
    if (positionRequestId !== undefined && positionRequestId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>positionRequestId,
        'positionRequestId'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/matching/accept`;
    return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createManualMatchingPositionRequestMatching(
    requestParameters?: HeadcountOverviewServiceCreateManualMatchingPositionRequestMatchingRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public createManualMatchingPositionRequestMatching(
    requestParameters?: HeadcountOverviewServiceCreateManualMatchingPositionRequestMatchingRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public createManualMatchingPositionRequestMatching(
    requestParameters?: HeadcountOverviewServiceCreateManualMatchingPositionRequestMatchingRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public createManualMatchingPositionRequestMatching(
    requestParameters?: HeadcountOverviewServiceCreateManualMatchingPositionRequestMatchingRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const headcountOverviewMatchingCreateManualPositionRequestMatchingModel =
      requestParameters?.headcountOverviewMatchingCreateManualPositionRequestMatchingModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/matching`;
    return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: headcountOverviewMatchingCreateManualPositionRequestMatchingModel,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createTeamMemberAvailabilityPeriods(
    requestParameters?: HeadcountOverviewServiceCreateTeamMemberAvailabilityPeriodsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public createTeamMemberAvailabilityPeriods(
    requestParameters?: HeadcountOverviewServiceCreateTeamMemberAvailabilityPeriodsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public createTeamMemberAvailabilityPeriods(
    requestParameters?: HeadcountOverviewServiceCreateTeamMemberAvailabilityPeriodsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public createTeamMemberAvailabilityPeriods(
    requestParameters?: HeadcountOverviewServiceCreateTeamMemberAvailabilityPeriodsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const teamMemberId = requestParameters?.teamMemberId;
    if (teamMemberId === null || teamMemberId === undefined) {
      throw new Error(
        'Required parameter teamMemberId was null or undefined when calling createTeamMemberAvailabilityPeriods.'
      );
    }
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;
    const headcountOverviewTeamMemberAvailabilityPeriodsCreateTeamMemberAvailabilityPeriodModel =
      requestParameters?.headcountOverviewTeamMemberAvailabilityPeriodsCreateTeamMemberAvailabilityPeriodModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/team-members/${this.configuration.encodeParam({ name: 'teamMemberId', value: teamMemberId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/availability-periods`;
    return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: headcountOverviewTeamMemberAvailabilityPeriodsCreateTeamMemberAvailabilityPeriodModel,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteDepartmentAdjustmentDepartmentAdjustments(
    requestParameters?: HeadcountOverviewServiceDeleteDepartmentAdjustmentDepartmentAdjustmentsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public deleteDepartmentAdjustmentDepartmentAdjustments(
    requestParameters?: HeadcountOverviewServiceDeleteDepartmentAdjustmentDepartmentAdjustmentsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public deleteDepartmentAdjustmentDepartmentAdjustments(
    requestParameters?: HeadcountOverviewServiceDeleteDepartmentAdjustmentDepartmentAdjustmentsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public deleteDepartmentAdjustmentDepartmentAdjustments(
    requestParameters?: HeadcountOverviewServiceDeleteDepartmentAdjustmentDepartmentAdjustmentsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const department = requestParameters?.department;
    if (department === null || department === undefined) {
      throw new Error(
        'Required parameter department was null or undefined when calling deleteDepartmentAdjustmentDepartmentAdjustments.'
      );
    }
    const costCenter = requestParameters?.costCenter;
    const areCode = requestParameters?.areCode;
    const depthStructure = requestParameters?.depthStructure;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (department !== undefined && department !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>department, 'Department');
    }
    if (costCenter !== undefined && costCenter !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>costCenter, 'CostCenter');
    }
    if (areCode !== undefined && areCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>areCode, 'AreCode');
    }
    if (depthStructure !== undefined && depthStructure !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>depthStructure, 'DepthStructure');
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/department-adjustments`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteTeamMemberAvailabilityPeriodTeamMemberAvailabilityPeriods(
    requestParameters?: HeadcountOverviewServiceDeleteTeamMemberAvailabilityPeriodTeamMemberAvailabilityPeriodsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public deleteTeamMemberAvailabilityPeriodTeamMemberAvailabilityPeriods(
    requestParameters?: HeadcountOverviewServiceDeleteTeamMemberAvailabilityPeriodTeamMemberAvailabilityPeriodsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public deleteTeamMemberAvailabilityPeriodTeamMemberAvailabilityPeriods(
    requestParameters?: HeadcountOverviewServiceDeleteTeamMemberAvailabilityPeriodTeamMemberAvailabilityPeriodsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public deleteTeamMemberAvailabilityPeriodTeamMemberAvailabilityPeriods(
    requestParameters?: HeadcountOverviewServiceDeleteTeamMemberAvailabilityPeriodTeamMemberAvailabilityPeriodsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const teamMemberId = requestParameters?.teamMemberId;
    if (teamMemberId === null || teamMemberId === undefined) {
      throw new Error(
        'Required parameter teamMemberId was null or undefined when calling deleteTeamMemberAvailabilityPeriodTeamMemberAvailabilityPeriods.'
      );
    }
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling deleteTeamMemberAvailabilityPeriodTeamMemberAvailabilityPeriods.'
      );
    }
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/team-members/${this.configuration.encodeParam({ name: 'teamMemberId', value: teamMemberId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/availability-periods/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteUltimoPhaseStartDateOverrideUltimoPhase(
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public deleteUltimoPhaseStartDateOverrideUltimoPhase(
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public deleteUltimoPhaseStartDateOverrideUltimoPhase(
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public deleteUltimoPhaseStartDateOverrideUltimoPhase(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/ultimo-phase/start-date-override`;
    return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportDepartmentAnalyticsReportExport(
    requestParameters?: HeadcountOverviewServiceExportDepartmentAnalyticsReportExportRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportDepartmentAnalyticsReportExport(
    requestParameters?: HeadcountOverviewServiceExportDepartmentAnalyticsReportExportRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportDepartmentAnalyticsReportExport(
    requestParameters?: HeadcountOverviewServiceExportDepartmentAnalyticsReportExportRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportDepartmentAnalyticsReportExport(
    requestParameters?: HeadcountOverviewServiceExportDepartmentAnalyticsReportExportRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const department = requestParameters?.department;
    if (department === null || department === undefined) {
      throw new Error(
        'Required parameter department was null or undefined when calling exportDepartmentAnalyticsReportExport.'
      );
    }
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error(
        'Required parameter startDate was null or undefined when calling exportDepartmentAnalyticsReportExport.'
      );
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error(
        'Required parameter endDate was null or undefined when calling exportDepartmentAnalyticsReportExport.'
      );
    }
    const filename = requestParameters?.filename;
    const showEmployees = requestParameters?.showEmployees;
    const showNewRequests = requestParameters?.showNewRequests;
    const showAdjustments = requestParameters?.showAdjustments;
    const areCode = requestParameters?.areCode;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const businessArea = requestParameters?.businessArea;
    const region = requestParameters?.region;
    const countryTitle = requestParameters?.countryTitle;
    const location = requestParameters?.location;
    const countryCostType = requestParameters?.countryCostType;
    const costCenter = requestParameters?.costCenter;
    const depthStructure = requestParameters?.depthStructure;
    const depthStructureText = requestParameters?.depthStructureText;
    const workforceType = requestParameters?.workforceType;
    const contractStatus = requestParameters?.contractStatus;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (department !== undefined && department !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>department, 'Department');
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (filename !== undefined && filename !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>filename, 'Filename');
    }
    if (showEmployees !== undefined && showEmployees !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showEmployees, 'ShowEmployees');
    }
    if (showNewRequests !== undefined && showNewRequests !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showNewRequests, 'ShowNewRequests');
    }
    if (showAdjustments !== undefined && showAdjustments !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showAdjustments, 'ShowAdjustments');
    }
    if (areCode) {
      areCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCode');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (businessArea) {
      businessArea.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'BusinessArea');
      });
    }
    if (region) {
      region.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Region');
      });
    }
    if (countryTitle) {
      countryTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryTitle');
      });
    }
    if (location) {
      location.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Location');
      });
    }
    if (countryCostType) {
      countryCostType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryCostType');
      });
    }
    if (costCenter) {
      costCenter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CostCenter');
      });
    }
    if (depthStructure) {
      depthStructure.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructure');
      });
    }
    if (depthStructureText) {
      depthStructureText.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructureText');
      });
    }
    if (workforceType) {
      workforceType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkforceType');
      });
    }
    if (contractStatus) {
      contractStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ContractStatus');
      });
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/analytics-report-export/department`;
    return this.httpClient.request<TransactionStatusOfExportStatusMetadata>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportListViewTeamMembersExport(
    requestParameters?: HeadcountOverviewServiceExportListViewTeamMembersExportRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportListViewTeamMembersExport(
    requestParameters?: HeadcountOverviewServiceExportListViewTeamMembersExportRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportListViewTeamMembersExport(
    requestParameters?: HeadcountOverviewServiceExportListViewTeamMembersExportRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportListViewTeamMembersExport(
    requestParameters?: HeadcountOverviewServiceExportListViewTeamMembersExportRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error(
        'Required parameter startDate was null or undefined when calling exportListViewTeamMembersExport.'
      );
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error('Required parameter endDate was null or undefined when calling exportListViewTeamMembersExport.');
    }
    const departments = requestParameters?.departments;
    const departmentsExcluding = requestParameters?.departmentsExcluding;
    const showEmployees = requestParameters?.showEmployees;
    const showNewRequests = requestParameters?.showNewRequests;
    const showAdjustments = requestParameters?.showAdjustments;
    const priorityEmployeeId = requestParameters?.priorityEmployeeId;
    const priorityPositionRequestId = requestParameters?.priorityPositionRequestId;
    const filename = requestParameters?.filename;
    const areCode = requestParameters?.areCode;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const businessArea = requestParameters?.businessArea;
    const region = requestParameters?.region;
    const countryTitle = requestParameters?.countryTitle;
    const location = requestParameters?.location;
    const countryCostType = requestParameters?.countryCostType;
    const costCenter = requestParameters?.costCenter;
    const depthStructure = requestParameters?.depthStructure;
    const depthStructureText = requestParameters?.depthStructureText;
    const workforceType = requestParameters?.workforceType;
    const contractStatus = requestParameters?.contractStatus;
    const orderBy = requestParameters?.orderBy;
    const property = requestParameters?.property;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (departments) {
      departments.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Departments');
      });
    }
    if (departmentsExcluding) {
      departmentsExcluding.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepartmentsExcluding');
      });
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (showEmployees !== undefined && showEmployees !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showEmployees, 'ShowEmployees');
    }
    if (showNewRequests !== undefined && showNewRequests !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showNewRequests, 'ShowNewRequests');
    }
    if (showAdjustments !== undefined && showAdjustments !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showAdjustments, 'ShowAdjustments');
    }
    if (priorityEmployeeId !== undefined && priorityEmployeeId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>priorityEmployeeId,
        'PriorityEmployeeId'
      );
    }
    if (priorityPositionRequestId !== undefined && priorityPositionRequestId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>priorityPositionRequestId,
        'PriorityPositionRequestId'
      );
    }
    if (filename !== undefined && filename !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>filename, 'Filename');
    }
    if (areCode) {
      areCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCode');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (businessArea) {
      businessArea.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'BusinessArea');
      });
    }
    if (region) {
      region.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Region');
      });
    }
    if (countryTitle) {
      countryTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryTitle');
      });
    }
    if (location) {
      location.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Location');
      });
    }
    if (countryCostType) {
      countryCostType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryCostType');
      });
    }
    if (costCenter) {
      costCenter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CostCenter');
      });
    }
    if (depthStructure) {
      depthStructure.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructure');
      });
    }
    if (depthStructureText) {
      depthStructureText.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructureText');
      });
    }
    if (workforceType) {
      workforceType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkforceType');
      });
    }
    if (contractStatus) {
      contractStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ContractStatus');
      });
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orderBy, 'OrderBy');
    }
    if (property !== undefined && property !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>property, 'Property');
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/list-view-team-member-export`;
    return this.httpClient.request<TransactionStatusOfExportStatusMetadata>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportTeamAnalyticsReportExport(
    requestParameters?: HeadcountOverviewServiceExportTeamAnalyticsReportExportRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportTeamAnalyticsReportExport(
    requestParameters?: HeadcountOverviewServiceExportTeamAnalyticsReportExportRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportTeamAnalyticsReportExport(
    requestParameters?: HeadcountOverviewServiceExportTeamAnalyticsReportExportRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportTeamAnalyticsReportExport(
    requestParameters?: HeadcountOverviewServiceExportTeamAnalyticsReportExportRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const department = requestParameters?.department;
    if (department === null || department === undefined) {
      throw new Error(
        'Required parameter department was null or undefined when calling exportTeamAnalyticsReportExport.'
      );
    }
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error(
        'Required parameter startDate was null or undefined when calling exportTeamAnalyticsReportExport.'
      );
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error('Required parameter endDate was null or undefined when calling exportTeamAnalyticsReportExport.');
    }
    const filename = requestParameters?.filename;
    const showEmployees = requestParameters?.showEmployees;
    const showNewRequests = requestParameters?.showNewRequests;
    const showAdjustments = requestParameters?.showAdjustments;
    const areCode = requestParameters?.areCode;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const businessArea = requestParameters?.businessArea;
    const region = requestParameters?.region;
    const countryTitle = requestParameters?.countryTitle;
    const location = requestParameters?.location;
    const countryCostType = requestParameters?.countryCostType;
    const costCenter = requestParameters?.costCenter;
    const depthStructure = requestParameters?.depthStructure;
    const depthStructureText = requestParameters?.depthStructureText;
    const workforceType = requestParameters?.workforceType;
    const contractStatus = requestParameters?.contractStatus;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (department !== undefined && department !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>department, 'Department');
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (filename !== undefined && filename !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>filename, 'Filename');
    }
    if (showEmployees !== undefined && showEmployees !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showEmployees, 'ShowEmployees');
    }
    if (showNewRequests !== undefined && showNewRequests !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showNewRequests, 'ShowNewRequests');
    }
    if (showAdjustments !== undefined && showAdjustments !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showAdjustments, 'ShowAdjustments');
    }
    if (areCode) {
      areCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCode');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (businessArea) {
      businessArea.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'BusinessArea');
      });
    }
    if (region) {
      region.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Region');
      });
    }
    if (countryTitle) {
      countryTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryTitle');
      });
    }
    if (location) {
      location.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Location');
      });
    }
    if (countryCostType) {
      countryCostType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryCostType');
      });
    }
    if (costCenter) {
      costCenter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CostCenter');
      });
    }
    if (depthStructure) {
      depthStructure.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructure');
      });
    }
    if (depthStructureText) {
      depthStructureText.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructureText');
      });
    }
    if (workforceType) {
      workforceType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkforceType');
      });
    }
    if (contractStatus) {
      contractStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ContractStatus');
      });
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/analytics-report-export/team`;
    return this.httpClient.request<TransactionStatusOfExportStatusMetadata>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAvailableEmployeesForMatchingPositionRequestMatching(
    requestParameters?: HeadcountOverviewServiceGetAvailableEmployeesForMatchingPositionRequestMatchingRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfHeadcountOverviewMatchingPositionRequestMatchingEmployeeModel>;
  public getAvailableEmployeesForMatchingPositionRequestMatching(
    requestParameters?: HeadcountOverviewServiceGetAvailableEmployeesForMatchingPositionRequestMatchingRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfHeadcountOverviewMatchingPositionRequestMatchingEmployeeModel>>;
  public getAvailableEmployeesForMatchingPositionRequestMatching(
    requestParameters?: HeadcountOverviewServiceGetAvailableEmployeesForMatchingPositionRequestMatchingRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfHeadcountOverviewMatchingPositionRequestMatchingEmployeeModel>>;
  public getAvailableEmployeesForMatchingPositionRequestMatching(
    requestParameters?: HeadcountOverviewServiceGetAvailableEmployeesForMatchingPositionRequestMatchingRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const positionRequestId = requestParameters?.positionRequestId;
    if (positionRequestId === null || positionRequestId === undefined) {
      throw new Error(
        'Required parameter positionRequestId was null or undefined when calling getAvailableEmployeesForMatchingPositionRequestMatching.'
      );
    }
    const searchTerm = requestParameters?.searchTerm;
    const page = requestParameters?.page;
    const size = requestParameters?.size;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (searchTerm !== undefined && searchTerm !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>searchTerm, 'SearchTerm');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/matching/${this.configuration.encodeParam({ name: 'positionRequestId', value: positionRequestId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/available-employees`;
    return this.httpClient.request<SharedPageModelOfHeadcountOverviewMatchingPositionRequestMatchingEmployeeModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getDepartmentAdjustmentDepartmentAdjustments(
    requestParameters?: HeadcountOverviewServiceGetDepartmentAdjustmentDepartmentAdjustmentsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HeadcountOverviewDepartmentsDepartmentAdjustmentsModel>;
  public getDepartmentAdjustmentDepartmentAdjustments(
    requestParameters?: HeadcountOverviewServiceGetDepartmentAdjustmentDepartmentAdjustmentsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<HeadcountOverviewDepartmentsDepartmentAdjustmentsModel>>;
  public getDepartmentAdjustmentDepartmentAdjustments(
    requestParameters?: HeadcountOverviewServiceGetDepartmentAdjustmentDepartmentAdjustmentsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<HeadcountOverviewDepartmentsDepartmentAdjustmentsModel>>;
  public getDepartmentAdjustmentDepartmentAdjustments(
    requestParameters?: HeadcountOverviewServiceGetDepartmentAdjustmentDepartmentAdjustmentsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const department = requestParameters?.department;
    if (department === null || department === undefined) {
      throw new Error(
        'Required parameter department was null or undefined when calling getDepartmentAdjustmentDepartmentAdjustments.'
      );
    }
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error(
        'Required parameter startDate was null or undefined when calling getDepartmentAdjustmentDepartmentAdjustments.'
      );
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error(
        'Required parameter endDate was null or undefined when calling getDepartmentAdjustmentDepartmentAdjustments.'
      );
    }
    const costCenter = requestParameters?.costCenter;
    const areCode = requestParameters?.areCode;
    const depthStructure = requestParameters?.depthStructure;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (department !== undefined && department !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>department, 'Department');
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (costCenter !== undefined && costCenter !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>costCenter, 'CostCenter');
    }
    if (areCode !== undefined && areCode !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>areCode, 'AreCode');
    }
    if (depthStructure !== undefined && depthStructure !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>depthStructure, 'DepthStructure');
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/department-adjustments/details`;
    return this.httpClient.request<HeadcountOverviewDepartmentsDepartmentAdjustmentsModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getDepartmentAdjustmentsDepartmentAdjustments(
    requestParameters?: HeadcountOverviewServiceGetDepartmentAdjustmentsDepartmentAdjustmentsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfHeadcountOverviewDepartmentsDepartmentAdjustmentsModel>;
  public getDepartmentAdjustmentsDepartmentAdjustments(
    requestParameters?: HeadcountOverviewServiceGetDepartmentAdjustmentsDepartmentAdjustmentsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfHeadcountOverviewDepartmentsDepartmentAdjustmentsModel>>;
  public getDepartmentAdjustmentsDepartmentAdjustments(
    requestParameters?: HeadcountOverviewServiceGetDepartmentAdjustmentsDepartmentAdjustmentsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfHeadcountOverviewDepartmentsDepartmentAdjustmentsModel>>;
  public getDepartmentAdjustmentsDepartmentAdjustments(
    requestParameters?: HeadcountOverviewServiceGetDepartmentAdjustmentsDepartmentAdjustmentsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error(
        'Required parameter startDate was null or undefined when calling getDepartmentAdjustmentsDepartmentAdjustments.'
      );
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error(
        'Required parameter endDate was null or undefined when calling getDepartmentAdjustmentsDepartmentAdjustments.'
      );
    }
    const departments = requestParameters?.departments;
    const departmentsExcluding = requestParameters?.departmentsExcluding;
    const businessArea = requestParameters?.businessArea;
    const headcountDisplayType = requestParameters?.headcountDisplayType;
    const costCenter = requestParameters?.costCenter;
    const areCode = requestParameters?.areCode;
    const depthStructure = requestParameters?.depthStructure;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (departments) {
      departments.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Departments');
      });
    }
    if (departmentsExcluding) {
      departmentsExcluding.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepartmentsExcluding');
      });
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (businessArea) {
      businessArea.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'BusinessArea');
      });
    }
    if (headcountDisplayType !== undefined && headcountDisplayType !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>headcountDisplayType,
        'HeadcountDisplayType'
      );
    }
    if (costCenter) {
      costCenter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CostCenter');
      });
    }
    if (areCode) {
      areCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCode');
      });
    }
    if (depthStructure) {
      depthStructure.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructure');
      });
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/department-adjustments`;
    return this.httpClient.request<SharedPageModelOfHeadcountOverviewDepartmentsDepartmentAdjustmentsModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getDepartmentBreadcrumbDepartmentBreadcrumb(
    requestParameters?: HeadcountOverviewServiceGetDepartmentBreadcrumbDepartmentBreadcrumbRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<HeadcountOverviewDepartmentsDepartmentBreadcrumbItemModel>>;
  public getDepartmentBreadcrumbDepartmentBreadcrumb(
    requestParameters?: HeadcountOverviewServiceGetDepartmentBreadcrumbDepartmentBreadcrumbRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<HeadcountOverviewDepartmentsDepartmentBreadcrumbItemModel>>>;
  public getDepartmentBreadcrumbDepartmentBreadcrumb(
    requestParameters?: HeadcountOverviewServiceGetDepartmentBreadcrumbDepartmentBreadcrumbRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<HeadcountOverviewDepartmentsDepartmentBreadcrumbItemModel>>>;
  public getDepartmentBreadcrumbDepartmentBreadcrumb(
    requestParameters?: HeadcountOverviewServiceGetDepartmentBreadcrumbDepartmentBreadcrumbRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const orgCode = requestParameters?.orgCode;
    if (orgCode === null || orgCode === undefined) {
      throw new Error(
        'Required parameter orgCode was null or undefined when calling getDepartmentBreadcrumbDepartmentBreadcrumb.'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/department-breadcrumb/${this.configuration.encodeParam({ name: 'orgCode', value: orgCode, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
    return this.httpClient.request<Array<HeadcountOverviewDepartmentsDepartmentBreadcrumbItemModel>>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getDepartmentReportAnalyticsFieldValues(
    requestParameters?: HeadcountOverviewServiceGetDepartmentReportAnalyticsFieldValuesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedFieldValuesModel>;
  public getDepartmentReportAnalyticsFieldValues(
    requestParameters?: HeadcountOverviewServiceGetDepartmentReportAnalyticsFieldValuesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedFieldValuesModel>>;
  public getDepartmentReportAnalyticsFieldValues(
    requestParameters?: HeadcountOverviewServiceGetDepartmentReportAnalyticsFieldValuesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedFieldValuesModel>>;
  public getDepartmentReportAnalyticsFieldValues(
    requestParameters?: HeadcountOverviewServiceGetDepartmentReportAnalyticsFieldValuesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const field = requestParameters?.field;
    if (field === null || field === undefined) {
      throw new Error(
        'Required parameter field was null or undefined when calling getDepartmentReportAnalyticsFieldValues.'
      );
    }
    const department = requestParameters?.department;
    if (department === null || department === undefined) {
      throw new Error(
        'Required parameter department was null or undefined when calling getDepartmentReportAnalyticsFieldValues.'
      );
    }
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error(
        'Required parameter startDate was null or undefined when calling getDepartmentReportAnalyticsFieldValues.'
      );
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error(
        'Required parameter endDate was null or undefined when calling getDepartmentReportAnalyticsFieldValues.'
      );
    }
    const search = requestParameters?.search;
    const showEmployees = requestParameters?.showEmployees;
    const showNewRequests = requestParameters?.showNewRequests;
    const showAdjustments = requestParameters?.showAdjustments;
    const areCode = requestParameters?.areCode;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const businessArea = requestParameters?.businessArea;
    const region = requestParameters?.region;
    const countryTitle = requestParameters?.countryTitle;
    const location = requestParameters?.location;
    const countryCostType = requestParameters?.countryCostType;
    const costCenter = requestParameters?.costCenter;
    const depthStructure = requestParameters?.depthStructure;
    const depthStructureText = requestParameters?.depthStructureText;
    const workforceType = requestParameters?.workforceType;
    const contractStatus = requestParameters?.contractStatus;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'search');
    }
    if (department !== undefined && department !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>department, 'Department');
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (showEmployees !== undefined && showEmployees !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showEmployees, 'ShowEmployees');
    }
    if (showNewRequests !== undefined && showNewRequests !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showNewRequests, 'ShowNewRequests');
    }
    if (showAdjustments !== undefined && showAdjustments !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showAdjustments, 'ShowAdjustments');
    }
    if (areCode) {
      areCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCode');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (businessArea) {
      businessArea.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'BusinessArea');
      });
    }
    if (region) {
      region.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Region');
      });
    }
    if (countryTitle) {
      countryTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryTitle');
      });
    }
    if (location) {
      location.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Location');
      });
    }
    if (countryCostType) {
      countryCostType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryCostType');
      });
    }
    if (costCenter) {
      costCenter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CostCenter');
      });
    }
    if (depthStructure) {
      depthStructure.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructure');
      });
    }
    if (depthStructureText) {
      depthStructureText.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructureText');
      });
    }
    if (workforceType) {
      workforceType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkforceType');
      });
    }
    if (contractStatus) {
      contractStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ContractStatus');
      });
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/analytics-field-values/department/${this.configuration.encodeParam({ name: 'field', value: field, in: 'path', style: 'simple', explode: false, dataType: "'AreCode' | 'OrgCode' | 'BusinessArea' | 'CountryTitle' | 'Region' | 'Location' | 'Gid' | 'CostCenter' | 'DepthStructure' | 'DepthStructureText' | 'ContractStatus' | 'WorkforceType'", dataFormat: undefined })}`;
    return this.httpClient.request<SharedFieldValuesModel>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getDepartmentReportAnalyticsReports(
    requestParameters?: HeadcountOverviewServiceGetDepartmentReportAnalyticsReportsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HeadcountOverviewAnalyticsReportModel>;
  public getDepartmentReportAnalyticsReports(
    requestParameters?: HeadcountOverviewServiceGetDepartmentReportAnalyticsReportsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<HeadcountOverviewAnalyticsReportModel>>;
  public getDepartmentReportAnalyticsReports(
    requestParameters?: HeadcountOverviewServiceGetDepartmentReportAnalyticsReportsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<HeadcountOverviewAnalyticsReportModel>>;
  public getDepartmentReportAnalyticsReports(
    requestParameters?: HeadcountOverviewServiceGetDepartmentReportAnalyticsReportsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const department = requestParameters?.department;
    if (department === null || department === undefined) {
      throw new Error(
        'Required parameter department was null or undefined when calling getDepartmentReportAnalyticsReports.'
      );
    }
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error(
        'Required parameter startDate was null or undefined when calling getDepartmentReportAnalyticsReports.'
      );
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error(
        'Required parameter endDate was null or undefined when calling getDepartmentReportAnalyticsReports.'
      );
    }
    const headcountDisplayType = requestParameters?.headcountDisplayType;
    if (headcountDisplayType === null || headcountDisplayType === undefined) {
      throw new Error(
        'Required parameter headcountDisplayType was null or undefined when calling getDepartmentReportAnalyticsReports.'
      );
    }
    const showEmployees = requestParameters?.showEmployees;
    const showNewRequests = requestParameters?.showNewRequests;
    const showAdjustments = requestParameters?.showAdjustments;
    const changeDisplayType = requestParameters?.changeDisplayType;
    const areCode = requestParameters?.areCode;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const businessArea = requestParameters?.businessArea;
    const region = requestParameters?.region;
    const countryTitle = requestParameters?.countryTitle;
    const location = requestParameters?.location;
    const countryCostType = requestParameters?.countryCostType;
    const costCenter = requestParameters?.costCenter;
    const depthStructure = requestParameters?.depthStructure;
    const depthStructureText = requestParameters?.depthStructureText;
    const workforceType = requestParameters?.workforceType;
    const contractStatus = requestParameters?.contractStatus;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (department !== undefined && department !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>department, 'Department');
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (headcountDisplayType !== undefined && headcountDisplayType !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>headcountDisplayType,
        'HeadcountDisplayType'
      );
    }
    if (showEmployees !== undefined && showEmployees !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showEmployees, 'ShowEmployees');
    }
    if (showNewRequests !== undefined && showNewRequests !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showNewRequests, 'ShowNewRequests');
    }
    if (showAdjustments !== undefined && showAdjustments !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showAdjustments, 'ShowAdjustments');
    }
    if (changeDisplayType !== undefined && changeDisplayType !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>changeDisplayType,
        'ChangeDisplayType'
      );
    }
    if (areCode) {
      areCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCode');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (businessArea) {
      businessArea.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'BusinessArea');
      });
    }
    if (region) {
      region.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Region');
      });
    }
    if (countryTitle) {
      countryTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryTitle');
      });
    }
    if (location) {
      location.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Location');
      });
    }
    if (countryCostType) {
      countryCostType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryCostType');
      });
    }
    if (costCenter) {
      costCenter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CostCenter');
      });
    }
    if (depthStructure) {
      depthStructure.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructure');
      });
    }
    if (depthStructureText) {
      depthStructureText.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructureText');
      });
    }
    if (workforceType) {
      workforceType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkforceType');
      });
    }
    if (contractStatus) {
      contractStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ContractStatus');
      });
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/headcount/overview/analytics-reports/department`;
    return this.httpClient.request<HeadcountOverviewAnalyticsReportModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getDetailsTeamMembers(
    requestParameters?: HeadcountOverviewServiceGetDetailsTeamMembersRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HeadcountOverviewDetailedTeamMembersTeamMemberDetailsModel>;
  public getDetailsTeamMembers(
    requestParameters?: HeadcountOverviewServiceGetDetailsTeamMembersRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<HeadcountOverviewDetailedTeamMembersTeamMemberDetailsModel>>;
  public getDetailsTeamMembers(
    requestParameters?: HeadcountOverviewServiceGetDetailsTeamMembersRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<HeadcountOverviewDetailedTeamMembersTeamMemberDetailsModel>>;
  public getDetailsTeamMembers(
    requestParameters?: HeadcountOverviewServiceGetDetailsTeamMembersRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error('Required parameter id was null or undefined when calling getDetailsTeamMembers.');
    }
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error('Required parameter startDate was null or undefined when calling getDetailsTeamMembers.');
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error('Required parameter endDate was null or undefined when calling getDetailsTeamMembers.');
    }
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/team-members/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/details`;
    return this.httpClient.request<HeadcountOverviewDetailedTeamMembersTeamMemberDetailsModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getMatchingsForPositionRequestPositionRequestMatching(
    requestParameters?: HeadcountOverviewServiceGetMatchingsForPositionRequestPositionRequestMatchingRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<Array<HeadcountOverviewMatchingPositionRequestMatchingModel>>;
  public getMatchingsForPositionRequestPositionRequestMatching(
    requestParameters?: HeadcountOverviewServiceGetMatchingsForPositionRequestPositionRequestMatchingRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<Array<HeadcountOverviewMatchingPositionRequestMatchingModel>>>;
  public getMatchingsForPositionRequestPositionRequestMatching(
    requestParameters?: HeadcountOverviewServiceGetMatchingsForPositionRequestPositionRequestMatchingRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<Array<HeadcountOverviewMatchingPositionRequestMatchingModel>>>;
  public getMatchingsForPositionRequestPositionRequestMatching(
    requestParameters?: HeadcountOverviewServiceGetMatchingsForPositionRequestPositionRequestMatchingRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const positionRequestId = requestParameters?.positionRequestId;
    if (positionRequestId === null || positionRequestId === undefined) {
      throw new Error(
        'Required parameter positionRequestId was null or undefined when calling getMatchingsForPositionRequestPositionRequestMatching.'
      );
    }
    const acknowledgeStatesFilter = requestParameters?.acknowledgeStatesFilter;
    const searchTerm = requestParameters?.searchTerm;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (acknowledgeStatesFilter) {
      acknowledgeStatesFilter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(
          localVarQueryParameters,
          <any>element,
          'AcknowledgeStatesFilter'
        );
      });
    }
    if (searchTerm !== undefined && searchTerm !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>searchTerm, 'SearchTerm');
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/matching/${this.configuration.encodeParam({ name: 'positionRequestId', value: positionRequestId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/matchings`;
    return this.httpClient.request<Array<HeadcountOverviewMatchingPositionRequestMatchingModel>>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTeamReportAnalyticsFieldValues(
    requestParameters?: HeadcountOverviewServiceGetTeamReportAnalyticsFieldValuesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedFieldValuesModel>;
  public getTeamReportAnalyticsFieldValues(
    requestParameters?: HeadcountOverviewServiceGetTeamReportAnalyticsFieldValuesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedFieldValuesModel>>;
  public getTeamReportAnalyticsFieldValues(
    requestParameters?: HeadcountOverviewServiceGetTeamReportAnalyticsFieldValuesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedFieldValuesModel>>;
  public getTeamReportAnalyticsFieldValues(
    requestParameters?: HeadcountOverviewServiceGetTeamReportAnalyticsFieldValuesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const field = requestParameters?.field;
    if (field === null || field === undefined) {
      throw new Error('Required parameter field was null or undefined when calling getTeamReportAnalyticsFieldValues.');
    }
    const department = requestParameters?.department;
    if (department === null || department === undefined) {
      throw new Error(
        'Required parameter department was null or undefined when calling getTeamReportAnalyticsFieldValues.'
      );
    }
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error(
        'Required parameter startDate was null or undefined when calling getTeamReportAnalyticsFieldValues.'
      );
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error(
        'Required parameter endDate was null or undefined when calling getTeamReportAnalyticsFieldValues.'
      );
    }
    const search = requestParameters?.search;
    const showEmployees = requestParameters?.showEmployees;
    const showNewRequests = requestParameters?.showNewRequests;
    const showAdjustments = requestParameters?.showAdjustments;
    const areCode = requestParameters?.areCode;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const businessArea = requestParameters?.businessArea;
    const region = requestParameters?.region;
    const countryTitle = requestParameters?.countryTitle;
    const location = requestParameters?.location;
    const countryCostType = requestParameters?.countryCostType;
    const costCenter = requestParameters?.costCenter;
    const depthStructure = requestParameters?.depthStructure;
    const depthStructureText = requestParameters?.depthStructureText;
    const workforceType = requestParameters?.workforceType;
    const contractStatus = requestParameters?.contractStatus;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'search');
    }
    if (department !== undefined && department !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>department, 'Department');
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (showEmployees !== undefined && showEmployees !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showEmployees, 'ShowEmployees');
    }
    if (showNewRequests !== undefined && showNewRequests !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showNewRequests, 'ShowNewRequests');
    }
    if (showAdjustments !== undefined && showAdjustments !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showAdjustments, 'ShowAdjustments');
    }
    if (areCode) {
      areCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCode');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (businessArea) {
      businessArea.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'BusinessArea');
      });
    }
    if (region) {
      region.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Region');
      });
    }
    if (countryTitle) {
      countryTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryTitle');
      });
    }
    if (location) {
      location.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Location');
      });
    }
    if (countryCostType) {
      countryCostType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryCostType');
      });
    }
    if (costCenter) {
      costCenter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CostCenter');
      });
    }
    if (depthStructure) {
      depthStructure.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructure');
      });
    }
    if (depthStructureText) {
      depthStructureText.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructureText');
      });
    }
    if (workforceType) {
      workforceType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkforceType');
      });
    }
    if (contractStatus) {
      contractStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ContractStatus');
      });
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/analytics-field-values/team/${this.configuration.encodeParam({ name: 'field', value: field, in: 'path', style: 'simple', explode: false, dataType: "'AreCode' | 'OrgCode' | 'BusinessArea' | 'CountryTitle' | 'Region' | 'Location' | 'Gid' | 'CostCenter' | 'DepthStructure' | 'DepthStructureText' | 'ContractStatus' | 'WorkforceType'", dataFormat: undefined })}`;
    return this.httpClient.request<SharedFieldValuesModel>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTeamReportAnalyticsReports(
    requestParameters?: HeadcountOverviewServiceGetTeamReportAnalyticsReportsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HeadcountOverviewAnalyticsReportModel>;
  public getTeamReportAnalyticsReports(
    requestParameters?: HeadcountOverviewServiceGetTeamReportAnalyticsReportsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<HeadcountOverviewAnalyticsReportModel>>;
  public getTeamReportAnalyticsReports(
    requestParameters?: HeadcountOverviewServiceGetTeamReportAnalyticsReportsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<HeadcountOverviewAnalyticsReportModel>>;
  public getTeamReportAnalyticsReports(
    requestParameters?: HeadcountOverviewServiceGetTeamReportAnalyticsReportsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const department = requestParameters?.department;
    if (department === null || department === undefined) {
      throw new Error(
        'Required parameter department was null or undefined when calling getTeamReportAnalyticsReports.'
      );
    }
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error('Required parameter startDate was null or undefined when calling getTeamReportAnalyticsReports.');
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error('Required parameter endDate was null or undefined when calling getTeamReportAnalyticsReports.');
    }
    const headcountDisplayType = requestParameters?.headcountDisplayType;
    if (headcountDisplayType === null || headcountDisplayType === undefined) {
      throw new Error(
        'Required parameter headcountDisplayType was null or undefined when calling getTeamReportAnalyticsReports.'
      );
    }
    const showEmployees = requestParameters?.showEmployees;
    const showNewRequests = requestParameters?.showNewRequests;
    const showAdjustments = requestParameters?.showAdjustments;
    const changeDisplayType = requestParameters?.changeDisplayType;
    const areCode = requestParameters?.areCode;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const businessArea = requestParameters?.businessArea;
    const region = requestParameters?.region;
    const countryTitle = requestParameters?.countryTitle;
    const location = requestParameters?.location;
    const countryCostType = requestParameters?.countryCostType;
    const costCenter = requestParameters?.costCenter;
    const depthStructure = requestParameters?.depthStructure;
    const depthStructureText = requestParameters?.depthStructureText;
    const workforceType = requestParameters?.workforceType;
    const contractStatus = requestParameters?.contractStatus;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (department !== undefined && department !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>department, 'Department');
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (headcountDisplayType !== undefined && headcountDisplayType !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>headcountDisplayType,
        'HeadcountDisplayType'
      );
    }
    if (showEmployees !== undefined && showEmployees !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showEmployees, 'ShowEmployees');
    }
    if (showNewRequests !== undefined && showNewRequests !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showNewRequests, 'ShowNewRequests');
    }
    if (showAdjustments !== undefined && showAdjustments !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showAdjustments, 'ShowAdjustments');
    }
    if (changeDisplayType !== undefined && changeDisplayType !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>changeDisplayType,
        'ChangeDisplayType'
      );
    }
    if (areCode) {
      areCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCode');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (businessArea) {
      businessArea.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'BusinessArea');
      });
    }
    if (region) {
      region.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Region');
      });
    }
    if (countryTitle) {
      countryTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryTitle');
      });
    }
    if (location) {
      location.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Location');
      });
    }
    if (countryCostType) {
      countryCostType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryCostType');
      });
    }
    if (costCenter) {
      costCenter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CostCenter');
      });
    }
    if (depthStructure) {
      depthStructure.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructure');
      });
    }
    if (depthStructureText) {
      depthStructureText.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructureText');
      });
    }
    if (workforceType) {
      workforceType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkforceType');
      });
    }
    if (contractStatus) {
      contractStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ContractStatus');
      });
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/headcount/overview/analytics-reports/team`;
    return this.httpClient.request<HeadcountOverviewAnalyticsReportModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public isReadOnlyModeUltimoPhase(
    requestParameters?: HeadcountOverviewServiceIsReadOnlyModeUltimoPhaseRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<boolean>;
  public isReadOnlyModeUltimoPhase(
    requestParameters?: HeadcountOverviewServiceIsReadOnlyModeUltimoPhaseRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<boolean>>;
  public isReadOnlyModeUltimoPhase(
    requestParameters?: HeadcountOverviewServiceIsReadOnlyModeUltimoPhaseRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<boolean>>;
  public isReadOnlyModeUltimoPhase(
    requestParameters?: HeadcountOverviewServiceIsReadOnlyModeUltimoPhaseRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/ultimo-phase`;
    return this.httpClient.request<boolean>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pageAnalyticsDepartmentCodesAnalyticsDepartmentCodes(
    requestParameters?: HeadcountOverviewServicePageAnalyticsDepartmentCodesAnalyticsDepartmentCodesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSystemString>;
  public pageAnalyticsDepartmentCodesAnalyticsDepartmentCodes(
    requestParameters?: HeadcountOverviewServicePageAnalyticsDepartmentCodesAnalyticsDepartmentCodesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSystemString>>;
  public pageAnalyticsDepartmentCodesAnalyticsDepartmentCodes(
    requestParameters?: HeadcountOverviewServicePageAnalyticsDepartmentCodesAnalyticsDepartmentCodesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSystemString>>;
  public pageAnalyticsDepartmentCodesAnalyticsDepartmentCodes(
    requestParameters?: HeadcountOverviewServicePageAnalyticsDepartmentCodesAnalyticsDepartmentCodesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error(
        'Required parameter startDate was null or undefined when calling pageAnalyticsDepartmentCodesAnalyticsDepartmentCodes.'
      );
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error(
        'Required parameter endDate was null or undefined when calling pageAnalyticsDepartmentCodesAnalyticsDepartmentCodes.'
      );
    }
    const businessArea = requestParameters?.businessArea;
    const search = requestParameters?.search;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (businessArea) {
      businessArea.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'BusinessArea');
      });
    }
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'search');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/analytics-department-codes`;
    return this.httpClient.request<SharedPageModelOfSystemString>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pageTeamDepartmentCodesTeamDepartmentCodes(
    requestParameters?: HeadcountOverviewServicePageTeamDepartmentCodesTeamDepartmentCodesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSystemString>;
  public pageTeamDepartmentCodesTeamDepartmentCodes(
    requestParameters?: HeadcountOverviewServicePageTeamDepartmentCodesTeamDepartmentCodesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSystemString>>;
  public pageTeamDepartmentCodesTeamDepartmentCodes(
    requestParameters?: HeadcountOverviewServicePageTeamDepartmentCodesTeamDepartmentCodesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSystemString>>;
  public pageTeamDepartmentCodesTeamDepartmentCodes(
    requestParameters?: HeadcountOverviewServicePageTeamDepartmentCodesTeamDepartmentCodesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error(
        'Required parameter startDate was null or undefined when calling pageTeamDepartmentCodesTeamDepartmentCodes.'
      );
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error(
        'Required parameter endDate was null or undefined when calling pageTeamDepartmentCodesTeamDepartmentCodes.'
      );
    }
    const businessArea = requestParameters?.businessArea;
    const search = requestParameters?.search;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (businessArea) {
      businessArea.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'BusinessArea');
      });
    }
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'search');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/team-department-codes`;
    return this.httpClient.request<SharedPageModelOfSystemString>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public postUltimoPhaseStartDateOverrideUltimoPhase(
    requestParameters?: HeadcountOverviewServicePostUltimoPhaseStartDateOverrideUltimoPhaseRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<string>;
  public postUltimoPhaseStartDateOverrideUltimoPhase(
    requestParameters?: HeadcountOverviewServicePostUltimoPhaseStartDateOverrideUltimoPhaseRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<string>>;
  public postUltimoPhaseStartDateOverrideUltimoPhase(
    requestParameters?: HeadcountOverviewServicePostUltimoPhaseStartDateOverrideUltimoPhaseRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<string>>;
  public postUltimoPhaseStartDateOverrideUltimoPhase(
    requestParameters?: HeadcountOverviewServicePostUltimoPhaseStartDateOverrideUltimoPhaseRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const body = requestParameters?.body;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/ultimo-phase/start-date-override`;
    return this.httpClient.request<string>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: body,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryAggregatedDepartmentAvailabilitiesAvailabilityAggregation(
    requestParameters?: HeadcountOverviewServiceQueryAggregatedDepartmentAvailabilitiesAvailabilityAggregationRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfHeadcountOverviewDepartmentsDepartmentModel>;
  public queryAggregatedDepartmentAvailabilitiesAvailabilityAggregation(
    requestParameters?: HeadcountOverviewServiceQueryAggregatedDepartmentAvailabilitiesAvailabilityAggregationRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfHeadcountOverviewDepartmentsDepartmentModel>>;
  public queryAggregatedDepartmentAvailabilitiesAvailabilityAggregation(
    requestParameters?: HeadcountOverviewServiceQueryAggregatedDepartmentAvailabilitiesAvailabilityAggregationRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfHeadcountOverviewDepartmentsDepartmentModel>>;
  public queryAggregatedDepartmentAvailabilitiesAvailabilityAggregation(
    requestParameters?: HeadcountOverviewServiceQueryAggregatedDepartmentAvailabilitiesAvailabilityAggregationRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const department = requestParameters?.department;
    if (department === null || department === undefined) {
      throw new Error(
        'Required parameter department was null or undefined when calling queryAggregatedDepartmentAvailabilitiesAvailabilityAggregation.'
      );
    }
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error(
        'Required parameter startDate was null or undefined when calling queryAggregatedDepartmentAvailabilitiesAvailabilityAggregation.'
      );
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error(
        'Required parameter endDate was null or undefined when calling queryAggregatedDepartmentAvailabilitiesAvailabilityAggregation.'
      );
    }
    const headcountDisplayType = requestParameters?.headcountDisplayType;
    if (headcountDisplayType === null || headcountDisplayType === undefined) {
      throw new Error(
        'Required parameter headcountDisplayType was null or undefined when calling queryAggregatedDepartmentAvailabilitiesAvailabilityAggregation.'
      );
    }
    const showEmployees = requestParameters?.showEmployees;
    const showNewRequests = requestParameters?.showNewRequests;
    const showAdjustments = requestParameters?.showAdjustments;
    const changeDisplayType = requestParameters?.changeDisplayType;
    const areCode = requestParameters?.areCode;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const businessArea = requestParameters?.businessArea;
    const region = requestParameters?.region;
    const countryTitle = requestParameters?.countryTitle;
    const location = requestParameters?.location;
    const countryCostType = requestParameters?.countryCostType;
    const costCenter = requestParameters?.costCenter;
    const depthStructure = requestParameters?.depthStructure;
    const depthStructureText = requestParameters?.depthStructureText;
    const workforceType = requestParameters?.workforceType;
    const contractStatus = requestParameters?.contractStatus;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (department !== undefined && department !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>department, 'Department');
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (showEmployees !== undefined && showEmployees !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showEmployees, 'ShowEmployees');
    }
    if (showNewRequests !== undefined && showNewRequests !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showNewRequests, 'ShowNewRequests');
    }
    if (showAdjustments !== undefined && showAdjustments !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showAdjustments, 'ShowAdjustments');
    }
    if (headcountDisplayType !== undefined && headcountDisplayType !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>headcountDisplayType,
        'HeadcountDisplayType'
      );
    }
    if (changeDisplayType !== undefined && changeDisplayType !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>changeDisplayType,
        'ChangeDisplayType'
      );
    }
    if (areCode) {
      areCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCode');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (businessArea) {
      businessArea.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'BusinessArea');
      });
    }
    if (region) {
      region.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Region');
      });
    }
    if (countryTitle) {
      countryTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryTitle');
      });
    }
    if (location) {
      location.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Location');
      });
    }
    if (countryCostType) {
      countryCostType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryCostType');
      });
    }
    if (costCenter) {
      costCenter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CostCenter');
      });
    }
    if (depthStructure) {
      depthStructure.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructure');
      });
    }
    if (depthStructureText) {
      depthStructureText.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructureText');
      });
    }
    if (workforceType) {
      workforceType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkforceType');
      });
    }
    if (contractStatus) {
      contractStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ContractStatus');
      });
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/availability-aggregation/departments`;
    return this.httpClient.request<SharedPageModelOfHeadcountOverviewDepartmentsDepartmentModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryAggregatedTeamMemberAvailabilitiesAvailabilityAggregation(
    requestParameters?: HeadcountOverviewServiceQueryAggregatedTeamMemberAvailabilitiesAvailabilityAggregationRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfHeadcountOverviewTeamMemberAvailabilityAggregationsTeamMemberAvailabilityAggregationModel>;
  public queryAggregatedTeamMemberAvailabilitiesAvailabilityAggregation(
    requestParameters?: HeadcountOverviewServiceQueryAggregatedTeamMemberAvailabilitiesAvailabilityAggregationRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<
    HttpResponse<SharedPageModelOfHeadcountOverviewTeamMemberAvailabilityAggregationsTeamMemberAvailabilityAggregationModel>
  >;
  public queryAggregatedTeamMemberAvailabilitiesAvailabilityAggregation(
    requestParameters?: HeadcountOverviewServiceQueryAggregatedTeamMemberAvailabilitiesAvailabilityAggregationRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<
    HttpEvent<SharedPageModelOfHeadcountOverviewTeamMemberAvailabilityAggregationsTeamMemberAvailabilityAggregationModel>
  >;
  public queryAggregatedTeamMemberAvailabilitiesAvailabilityAggregation(
    requestParameters?: HeadcountOverviewServiceQueryAggregatedTeamMemberAvailabilitiesAvailabilityAggregationRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error(
        'Required parameter startDate was null or undefined when calling queryAggregatedTeamMemberAvailabilitiesAvailabilityAggregation.'
      );
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error(
        'Required parameter endDate was null or undefined when calling queryAggregatedTeamMemberAvailabilitiesAvailabilityAggregation.'
      );
    }
    const departments = requestParameters?.departments;
    const departmentsExcluding = requestParameters?.departmentsExcluding;
    const showEmployees = requestParameters?.showEmployees;
    const showNewRequests = requestParameters?.showNewRequests;
    const priorityEmployeeId = requestParameters?.priorityEmployeeId;
    const priorityPositionRequestId = requestParameters?.priorityPositionRequestId;
    const areCode = requestParameters?.areCode;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const businessArea = requestParameters?.businessArea;
    const region = requestParameters?.region;
    const countryTitle = requestParameters?.countryTitle;
    const location = requestParameters?.location;
    const countryCostType = requestParameters?.countryCostType;
    const costCenter = requestParameters?.costCenter;
    const depthStructure = requestParameters?.depthStructure;
    const depthStructureText = requestParameters?.depthStructureText;
    const workforceType = requestParameters?.workforceType;
    const contractStatus = requestParameters?.contractStatus;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const orderBy = requestParameters?.orderBy;
    const property = requestParameters?.property;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (departments) {
      departments.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Departments');
      });
    }
    if (departmentsExcluding) {
      departmentsExcluding.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepartmentsExcluding');
      });
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (showEmployees !== undefined && showEmployees !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showEmployees, 'ShowEmployees');
    }
    if (showNewRequests !== undefined && showNewRequests !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>showNewRequests, 'ShowNewRequests');
    }
    if (priorityEmployeeId !== undefined && priorityEmployeeId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>priorityEmployeeId,
        'PriorityEmployeeId'
      );
    }
    if (priorityPositionRequestId !== undefined && priorityPositionRequestId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>priorityPositionRequestId,
        'PriorityPositionRequestId'
      );
    }
    if (areCode) {
      areCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCode');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (businessArea) {
      businessArea.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'BusinessArea');
      });
    }
    if (region) {
      region.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Region');
      });
    }
    if (countryTitle) {
      countryTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryTitle');
      });
    }
    if (location) {
      location.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Location');
      });
    }
    if (countryCostType) {
      countryCostType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryCostType');
      });
    }
    if (costCenter) {
      costCenter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CostCenter');
      });
    }
    if (depthStructure) {
      depthStructure.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructure');
      });
    }
    if (depthStructureText) {
      depthStructureText.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructureText');
      });
    }
    if (workforceType) {
      workforceType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkforceType');
      });
    }
    if (contractStatus) {
      contractStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ContractStatus');
      });
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orderBy, 'OrderBy');
    }
    if (property !== undefined && property !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>property, 'Property');
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/availability-aggregation/team-members`;
    return this.httpClient.request<SharedPageModelOfHeadcountOverviewTeamMemberAvailabilityAggregationsTeamMemberAvailabilityAggregationModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryBusinessAreasBusinessAreas(
    requestParameters?: HeadcountOverviewServiceQueryBusinessAreasBusinessAreasRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfSystemString>;
  public queryBusinessAreasBusinessAreas(
    requestParameters?: HeadcountOverviewServiceQueryBusinessAreasBusinessAreasRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfSystemString>>;
  public queryBusinessAreasBusinessAreas(
    requestParameters?: HeadcountOverviewServiceQueryBusinessAreasBusinessAreasRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfSystemString>>;
  public queryBusinessAreasBusinessAreas(
    requestParameters?: HeadcountOverviewServiceQueryBusinessAreasBusinessAreasRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/headcount/overview/business-areas`;
    return this.httpClient.request<SharedPageModelOfSystemString>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesTeamMemberFieldValues(
    requestParameters?: HeadcountOverviewServiceQueryFieldValuesTeamMemberFieldValuesRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedFieldValuesModel>;
  public queryFieldValuesTeamMemberFieldValues(
    requestParameters?: HeadcountOverviewServiceQueryFieldValuesTeamMemberFieldValuesRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedFieldValuesModel>>;
  public queryFieldValuesTeamMemberFieldValues(
    requestParameters?: HeadcountOverviewServiceQueryFieldValuesTeamMemberFieldValuesRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedFieldValuesModel>>;
  public queryFieldValuesTeamMemberFieldValues(
    requestParameters?: HeadcountOverviewServiceQueryFieldValuesTeamMemberFieldValuesRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const field = requestParameters?.field;
    if (field === null || field === undefined) {
      throw new Error(
        'Required parameter field was null or undefined when calling queryFieldValuesTeamMemberFieldValues.'
      );
    }
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error(
        'Required parameter startDate was null or undefined when calling queryFieldValuesTeamMemberFieldValues.'
      );
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error(
        'Required parameter endDate was null or undefined when calling queryFieldValuesTeamMemberFieldValues.'
      );
    }
    const search = requestParameters?.search;
    const departments = requestParameters?.departments;
    const departmentsExcluding = requestParameters?.departmentsExcluding;
    const areCode = requestParameters?.areCode;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const businessArea = requestParameters?.businessArea;
    const region = requestParameters?.region;
    const countryTitle = requestParameters?.countryTitle;
    const location = requestParameters?.location;
    const countryCostType = requestParameters?.countryCostType;
    const costCenter = requestParameters?.costCenter;
    const depthStructure = requestParameters?.depthStructure;
    const depthStructureText = requestParameters?.depthStructureText;
    const workforceType = requestParameters?.workforceType;
    const contractStatus = requestParameters?.contractStatus;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'search');
    }
    if (departments) {
      departments.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Departments');
      });
    }
    if (departmentsExcluding) {
      departmentsExcluding.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepartmentsExcluding');
      });
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (areCode) {
      areCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCode');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (businessArea) {
      businessArea.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'BusinessArea');
      });
    }
    if (region) {
      region.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Region');
      });
    }
    if (countryTitle) {
      countryTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryTitle');
      });
    }
    if (location) {
      location.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Location');
      });
    }
    if (countryCostType) {
      countryCostType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryCostType');
      });
    }
    if (costCenter) {
      costCenter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CostCenter');
      });
    }
    if (depthStructure) {
      depthStructure.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructure');
      });
    }
    if (depthStructureText) {
      depthStructureText.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructureText');
      });
    }
    if (workforceType) {
      workforceType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkforceType');
      });
    }
    if (contractStatus) {
      contractStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ContractStatus');
      });
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/team-member-field-values/${this.configuration.encodeParam({ name: 'field', value: field, in: 'path', style: 'simple', explode: false, dataType: "'AreCode' | 'OrgCode' | 'BusinessArea' | 'CountryTitle' | 'Region' | 'Location' | 'Gid' | 'CostCenter' | 'DepthStructure' | 'DepthStructureText' | 'ContractStatus' | 'WorkforceType'", dataFormat: undefined })}`;
    return this.httpClient.request<SharedFieldValuesModel>('get', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryIrrelevantAnalyticsTeamMember(
    requestParameters?: HeadcountOverviewServiceQueryIrrelevantAnalyticsTeamMemberRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfHeadcountOverviewTeamMemberAvailabilityAggregationsTeamMemberAvailabilityAggregationModel>;
  public queryIrrelevantAnalyticsTeamMember(
    requestParameters?: HeadcountOverviewServiceQueryIrrelevantAnalyticsTeamMemberRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<
    HttpResponse<SharedPageModelOfHeadcountOverviewTeamMemberAvailabilityAggregationsTeamMemberAvailabilityAggregationModel>
  >;
  public queryIrrelevantAnalyticsTeamMember(
    requestParameters?: HeadcountOverviewServiceQueryIrrelevantAnalyticsTeamMemberRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<
    HttpEvent<SharedPageModelOfHeadcountOverviewTeamMemberAvailabilityAggregationsTeamMemberAvailabilityAggregationModel>
  >;
  public queryIrrelevantAnalyticsTeamMember(
    requestParameters?: HeadcountOverviewServiceQueryIrrelevantAnalyticsTeamMemberRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const department = requestParameters?.department;
    if (department === null || department === undefined) {
      throw new Error(
        'Required parameter department was null or undefined when calling queryIrrelevantAnalyticsTeamMember.'
      );
    }
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error(
        'Required parameter startDate was null or undefined when calling queryIrrelevantAnalyticsTeamMember.'
      );
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error(
        'Required parameter endDate was null or undefined when calling queryIrrelevantAnalyticsTeamMember.'
      );
    }
    const areCode = requestParameters?.areCode;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const businessArea = requestParameters?.businessArea;
    const region = requestParameters?.region;
    const countryTitle = requestParameters?.countryTitle;
    const location = requestParameters?.location;
    const countryCostType = requestParameters?.countryCostType;
    const costCenter = requestParameters?.costCenter;
    const depthStructure = requestParameters?.depthStructure;
    const depthStructureText = requestParameters?.depthStructureText;
    const workforceType = requestParameters?.workforceType;
    const contractStatus = requestParameters?.contractStatus;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const orderBy = requestParameters?.orderBy;
    const property = requestParameters?.property;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (department !== undefined && department !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>department, 'Department');
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (areCode) {
      areCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCode');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (businessArea) {
      businessArea.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'BusinessArea');
      });
    }
    if (region) {
      region.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Region');
      });
    }
    if (countryTitle) {
      countryTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryTitle');
      });
    }
    if (location) {
      location.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Location');
      });
    }
    if (countryCostType) {
      countryCostType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryCostType');
      });
    }
    if (costCenter) {
      costCenter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CostCenter');
      });
    }
    if (depthStructure) {
      depthStructure.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructure');
      });
    }
    if (depthStructureText) {
      depthStructureText.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructureText');
      });
    }
    if (workforceType) {
      workforceType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkforceType');
      });
    }
    if (contractStatus) {
      contractStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ContractStatus');
      });
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orderBy, 'OrderBy');
    }
    if (property !== undefined && property !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>property, 'Property');
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/availability-aggregation/team-members/irrelevant`;
    return this.httpClient.request<SharedPageModelOfHeadcountOverviewTeamMemberAvailabilityAggregationsTeamMemberAvailabilityAggregationModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryIrrelevantPositionRequestsAnalyticsTeamMember(
    requestParameters?: HeadcountOverviewServiceQueryIrrelevantPositionRequestsAnalyticsTeamMemberRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfHeadcountOverviewTeamMemberAvailabilityAggregationsTeamMemberAvailabilityAggregationModel>;
  public queryIrrelevantPositionRequestsAnalyticsTeamMember(
    requestParameters?: HeadcountOverviewServiceQueryIrrelevantPositionRequestsAnalyticsTeamMemberRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<
    HttpResponse<SharedPageModelOfHeadcountOverviewTeamMemberAvailabilityAggregationsTeamMemberAvailabilityAggregationModel>
  >;
  public queryIrrelevantPositionRequestsAnalyticsTeamMember(
    requestParameters?: HeadcountOverviewServiceQueryIrrelevantPositionRequestsAnalyticsTeamMemberRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<
    HttpEvent<SharedPageModelOfHeadcountOverviewTeamMemberAvailabilityAggregationsTeamMemberAvailabilityAggregationModel>
  >;
  public queryIrrelevantPositionRequestsAnalyticsTeamMember(
    requestParameters?: HeadcountOverviewServiceQueryIrrelevantPositionRequestsAnalyticsTeamMemberRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const department = requestParameters?.department;
    if (department === null || department === undefined) {
      throw new Error(
        'Required parameter department was null or undefined when calling queryIrrelevantPositionRequestsAnalyticsTeamMember.'
      );
    }
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error(
        'Required parameter startDate was null or undefined when calling queryIrrelevantPositionRequestsAnalyticsTeamMember.'
      );
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error(
        'Required parameter endDate was null or undefined when calling queryIrrelevantPositionRequestsAnalyticsTeamMember.'
      );
    }
    const areCode = requestParameters?.areCode;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const businessArea = requestParameters?.businessArea;
    const region = requestParameters?.region;
    const countryTitle = requestParameters?.countryTitle;
    const location = requestParameters?.location;
    const countryCostType = requestParameters?.countryCostType;
    const costCenter = requestParameters?.costCenter;
    const depthStructure = requestParameters?.depthStructure;
    const depthStructureText = requestParameters?.depthStructureText;
    const workforceType = requestParameters?.workforceType;
    const contractStatus = requestParameters?.contractStatus;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const orderBy = requestParameters?.orderBy;
    const property = requestParameters?.property;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (department !== undefined && department !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>department, 'Department');
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (areCode) {
      areCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCode');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (businessArea) {
      businessArea.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'BusinessArea');
      });
    }
    if (region) {
      region.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Region');
      });
    }
    if (countryTitle) {
      countryTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryTitle');
      });
    }
    if (location) {
      location.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Location');
      });
    }
    if (countryCostType) {
      countryCostType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryCostType');
      });
    }
    if (costCenter) {
      costCenter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CostCenter');
      });
    }
    if (depthStructure) {
      depthStructure.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructure');
      });
    }
    if (depthStructureText) {
      depthStructureText.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructureText');
      });
    }
    if (workforceType) {
      workforceType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkforceType');
      });
    }
    if (contractStatus) {
      contractStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ContractStatus');
      });
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orderBy, 'OrderBy');
    }
    if (property !== undefined && property !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>property, 'Property');
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/availability-aggregation/team-members/irrelevant-position-requests`;
    return this.httpClient.request<SharedPageModelOfHeadcountOverviewTeamMemberAvailabilityAggregationsTeamMemberAvailabilityAggregationModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryRelevantAnalyticsTeamMember(
    requestParameters?: HeadcountOverviewServiceQueryRelevantAnalyticsTeamMemberRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfHeadcountOverviewTeamMemberAvailabilityAggregationsTeamMemberAvailabilityAggregationModel>;
  public queryRelevantAnalyticsTeamMember(
    requestParameters?: HeadcountOverviewServiceQueryRelevantAnalyticsTeamMemberRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<
    HttpResponse<SharedPageModelOfHeadcountOverviewTeamMemberAvailabilityAggregationsTeamMemberAvailabilityAggregationModel>
  >;
  public queryRelevantAnalyticsTeamMember(
    requestParameters?: HeadcountOverviewServiceQueryRelevantAnalyticsTeamMemberRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<
    HttpEvent<SharedPageModelOfHeadcountOverviewTeamMemberAvailabilityAggregationsTeamMemberAvailabilityAggregationModel>
  >;
  public queryRelevantAnalyticsTeamMember(
    requestParameters?: HeadcountOverviewServiceQueryRelevantAnalyticsTeamMemberRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const department = requestParameters?.department;
    if (department === null || department === undefined) {
      throw new Error(
        'Required parameter department was null or undefined when calling queryRelevantAnalyticsTeamMember.'
      );
    }
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error(
        'Required parameter startDate was null or undefined when calling queryRelevantAnalyticsTeamMember.'
      );
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error(
        'Required parameter endDate was null or undefined when calling queryRelevantAnalyticsTeamMember.'
      );
    }
    const areCode = requestParameters?.areCode;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const businessArea = requestParameters?.businessArea;
    const region = requestParameters?.region;
    const countryTitle = requestParameters?.countryTitle;
    const location = requestParameters?.location;
    const countryCostType = requestParameters?.countryCostType;
    const costCenter = requestParameters?.costCenter;
    const depthStructure = requestParameters?.depthStructure;
    const depthStructureText = requestParameters?.depthStructureText;
    const workforceType = requestParameters?.workforceType;
    const contractStatus = requestParameters?.contractStatus;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const orderBy = requestParameters?.orderBy;
    const property = requestParameters?.property;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (department !== undefined && department !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>department, 'Department');
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (areCode) {
      areCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCode');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (businessArea) {
      businessArea.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'BusinessArea');
      });
    }
    if (region) {
      region.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Region');
      });
    }
    if (countryTitle) {
      countryTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryTitle');
      });
    }
    if (location) {
      location.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Location');
      });
    }
    if (countryCostType) {
      countryCostType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryCostType');
      });
    }
    if (costCenter) {
      costCenter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CostCenter');
      });
    }
    if (depthStructure) {
      depthStructure.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructure');
      });
    }
    if (depthStructureText) {
      depthStructureText.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructureText');
      });
    }
    if (workforceType) {
      workforceType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkforceType');
      });
    }
    if (contractStatus) {
      contractStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ContractStatus');
      });
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orderBy, 'OrderBy');
    }
    if (property !== undefined && property !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>property, 'Property');
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/availability-aggregation/team-members/relevant`;
    return this.httpClient.request<SharedPageModelOfHeadcountOverviewTeamMemberAvailabilityAggregationsTeamMemberAvailabilityAggregationModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryRelevantPositionRequestsAnalyticsTeamMember(
    requestParameters?: HeadcountOverviewServiceQueryRelevantPositionRequestsAnalyticsTeamMemberRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfHeadcountOverviewTeamMemberAvailabilityAggregationsTeamMemberAvailabilityAggregationModel>;
  public queryRelevantPositionRequestsAnalyticsTeamMember(
    requestParameters?: HeadcountOverviewServiceQueryRelevantPositionRequestsAnalyticsTeamMemberRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<
    HttpResponse<SharedPageModelOfHeadcountOverviewTeamMemberAvailabilityAggregationsTeamMemberAvailabilityAggregationModel>
  >;
  public queryRelevantPositionRequestsAnalyticsTeamMember(
    requestParameters?: HeadcountOverviewServiceQueryRelevantPositionRequestsAnalyticsTeamMemberRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<
    HttpEvent<SharedPageModelOfHeadcountOverviewTeamMemberAvailabilityAggregationsTeamMemberAvailabilityAggregationModel>
  >;
  public queryRelevantPositionRequestsAnalyticsTeamMember(
    requestParameters?: HeadcountOverviewServiceQueryRelevantPositionRequestsAnalyticsTeamMemberRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const department = requestParameters?.department;
    if (department === null || department === undefined) {
      throw new Error(
        'Required parameter department was null or undefined when calling queryRelevantPositionRequestsAnalyticsTeamMember.'
      );
    }
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error(
        'Required parameter startDate was null or undefined when calling queryRelevantPositionRequestsAnalyticsTeamMember.'
      );
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error(
        'Required parameter endDate was null or undefined when calling queryRelevantPositionRequestsAnalyticsTeamMember.'
      );
    }
    const areCode = requestParameters?.areCode;
    const orgCode = requestParameters?.orgCode;
    const orgCodeStartsWith = requestParameters?.orgCodeStartsWith;
    const businessArea = requestParameters?.businessArea;
    const region = requestParameters?.region;
    const countryTitle = requestParameters?.countryTitle;
    const location = requestParameters?.location;
    const countryCostType = requestParameters?.countryCostType;
    const costCenter = requestParameters?.costCenter;
    const depthStructure = requestParameters?.depthStructure;
    const depthStructureText = requestParameters?.depthStructureText;
    const workforceType = requestParameters?.workforceType;
    const contractStatus = requestParameters?.contractStatus;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const orderBy = requestParameters?.orderBy;
    const property = requestParameters?.property;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (department !== undefined && department !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>department, 'Department');
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (areCode) {
      areCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'AreCode');
      });
    }
    if (orgCode) {
      orgCode.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'OrgCode');
      });
    }
    if (orgCodeStartsWith !== undefined && orgCodeStartsWith !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>orgCodeStartsWith,
        'OrgCodeStartsWith'
      );
    }
    if (businessArea) {
      businessArea.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'BusinessArea');
      });
    }
    if (region) {
      region.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Region');
      });
    }
    if (countryTitle) {
      countryTitle.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryTitle');
      });
    }
    if (location) {
      location.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Location');
      });
    }
    if (countryCostType) {
      countryCostType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CountryCostType');
      });
    }
    if (costCenter) {
      costCenter.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'CostCenter');
      });
    }
    if (depthStructure) {
      depthStructure.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructure');
      });
    }
    if (depthStructureText) {
      depthStructureText.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepthStructureText');
      });
    }
    if (workforceType) {
      workforceType.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'WorkforceType');
      });
    }
    if (contractStatus) {
      contractStatus.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'ContractStatus');
      });
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orderBy, 'OrderBy');
    }
    if (property !== undefined && property !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>property, 'Property');
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/availability-aggregation/team-members/relevant-position-requests`;
    return this.httpClient.request<SharedPageModelOfHeadcountOverviewTeamMemberAvailabilityAggregationsTeamMemberAvailabilityAggregationModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryTeamMemberAvailabilityPeriods(
    requestParameters?: HeadcountOverviewServiceQueryTeamMemberAvailabilityPeriodsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfHeadcountOverviewTeamMemberAvailabilityPeriodsTeamMemberAvailabilityPeriodModel>;
  public queryTeamMemberAvailabilityPeriods(
    requestParameters?: HeadcountOverviewServiceQueryTeamMemberAvailabilityPeriodsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<
    HttpResponse<SharedPageModelOfHeadcountOverviewTeamMemberAvailabilityPeriodsTeamMemberAvailabilityPeriodModel>
  >;
  public queryTeamMemberAvailabilityPeriods(
    requestParameters?: HeadcountOverviewServiceQueryTeamMemberAvailabilityPeriodsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<
    HttpEvent<SharedPageModelOfHeadcountOverviewTeamMemberAvailabilityPeriodsTeamMemberAvailabilityPeriodModel>
  >;
  public queryTeamMemberAvailabilityPeriods(
    requestParameters?: HeadcountOverviewServiceQueryTeamMemberAvailabilityPeriodsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const teamMemberId = requestParameters?.teamMemberId;
    if (teamMemberId === null || teamMemberId === undefined) {
      throw new Error(
        'Required parameter teamMemberId was null or undefined when calling queryTeamMemberAvailabilityPeriods.'
      );
    }
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error(
        'Required parameter startDate was null or undefined when calling queryTeamMemberAvailabilityPeriods.'
      );
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error(
        'Required parameter endDate was null or undefined when calling queryTeamMemberAvailabilityPeriods.'
      );
    }
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/team-members/${this.configuration.encodeParam({ name: 'teamMemberId', value: teamMemberId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/availability-periods`;
    return this.httpClient.request<SharedPageModelOfHeadcountOverviewTeamMemberAvailabilityPeriodsTeamMemberAvailabilityPeriodModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryTeamMembers(
    requestParameters?: HeadcountOverviewServiceQueryTeamMembersRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<SharedPageModelOfHeadcountOverviewTeamMembersTeamMemberModel>;
  public queryTeamMembers(
    requestParameters?: HeadcountOverviewServiceQueryTeamMembersRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<SharedPageModelOfHeadcountOverviewTeamMembersTeamMemberModel>>;
  public queryTeamMembers(
    requestParameters?: HeadcountOverviewServiceQueryTeamMembersRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<SharedPageModelOfHeadcountOverviewTeamMembersTeamMemberModel>>;
  public queryTeamMembers(
    requestParameters?: HeadcountOverviewServiceQueryTeamMembersRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error('Required parameter startDate was null or undefined when calling queryTeamMembers.');
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error('Required parameter endDate was null or undefined when calling queryTeamMembers.');
    }
    const search = requestParameters?.search;
    const departments = requestParameters?.departments;
    const departmentsExcluding = requestParameters?.departmentsExcluding;
    const page = requestParameters?.page;
    const size = requestParameters?.size;
    const orderBy = requestParameters?.orderBy;
    const property = requestParameters?.property;
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (search !== undefined && search !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>search, 'search');
    }
    if (departments) {
      departments.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'Departments');
      });
    }
    if (departmentsExcluding) {
      departmentsExcluding.forEach(element => {
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>element, 'DepartmentsExcluding');
      });
    }
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (page !== undefined && page !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>page, 'Page');
    }
    if (size !== undefined && size !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>size, 'Size');
    }
    if (orderBy !== undefined && orderBy !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>orderBy, 'OrderBy');
    }
    if (property !== undefined && property !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>property, 'Property');
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/team-members`;
    return this.httpClient.request<SharedPageModelOfHeadcountOverviewTeamMembersTeamMemberModel>(
      'get',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        params: localVarQueryParameters,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public recalculateEmployeeAvailability(
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<string>;
  public recalculateEmployeeAvailability(
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<string>>;
  public recalculateEmployeeAvailability(
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<string>>;
  public recalculateEmployeeAvailability(
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/customer/headcount/overview/availability/recalculate`;
    return this.httpClient.request<string>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public rejectMatchingPositionRequestMatching(
    requestParameters?: HeadcountOverviewServiceRejectMatchingPositionRequestMatchingRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public rejectMatchingPositionRequestMatching(
    requestParameters?: HeadcountOverviewServiceRejectMatchingPositionRequestMatchingRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public rejectMatchingPositionRequestMatching(
    requestParameters?: HeadcountOverviewServiceRejectMatchingPositionRequestMatchingRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public rejectMatchingPositionRequestMatching(
    requestParameters?: HeadcountOverviewServiceRejectMatchingPositionRequestMatchingRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const employeeId = requestParameters?.employeeId;
    const positionRequestId = requestParameters?.positionRequestId;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (employeeId !== undefined && employeeId !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>employeeId, 'employeeId');
    }
    if (positionRequestId !== undefined && positionRequestId !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>positionRequestId,
        'positionRequestId'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/matching/reject`;
    return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public resetMatchingPositionRequestMatching(
    requestParameters?: HeadcountOverviewServiceResetMatchingPositionRequestMatchingRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public resetMatchingPositionRequestMatching(
    requestParameters?: HeadcountOverviewServiceResetMatchingPositionRequestMatchingRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public resetMatchingPositionRequestMatching(
    requestParameters?: HeadcountOverviewServiceResetMatchingPositionRequestMatchingRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public resetMatchingPositionRequestMatching(
    requestParameters?: HeadcountOverviewServiceResetMatchingPositionRequestMatchingRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const headcountOverviewMatchingResetPositionRequestMatchingModel =
      requestParameters?.headcountOverviewMatchingResetPositionRequestMatchingModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/matching/reset`;
    return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: headcountOverviewMatchingResetPositionRequestMatchingModel,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateDepartmentAdjustmentsDepartmentAdjustments(
    requestParameters?: HeadcountOverviewServiceUpdateDepartmentAdjustmentsDepartmentAdjustmentsRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public updateDepartmentAdjustmentsDepartmentAdjustments(
    requestParameters?: HeadcountOverviewServiceUpdateDepartmentAdjustmentsDepartmentAdjustmentsRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public updateDepartmentAdjustmentsDepartmentAdjustments(
    requestParameters?: HeadcountOverviewServiceUpdateDepartmentAdjustmentsDepartmentAdjustmentsRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public updateDepartmentAdjustmentsDepartmentAdjustments(
    requestParameters?: HeadcountOverviewServiceUpdateDepartmentAdjustmentsDepartmentAdjustmentsRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;
    const headcountOverviewDepartmentsUpdateDepartmentAdjustmentsModel =
      requestParameters?.headcountOverviewDepartmentsUpdateDepartmentAdjustmentsModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/department-adjustments`;
    return this.httpClient.request<any>('post', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: headcountOverviewDepartmentsUpdateDepartmentAdjustmentsModel,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateManyTeamMemberAvailabilitiesTeamMembers(
    requestParameters?: HeadcountOverviewServiceUpdateManyTeamMemberAvailabilitiesTeamMembersRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any>;
  public updateManyTeamMemberAvailabilitiesTeamMembers(
    requestParameters?: HeadcountOverviewServiceUpdateManyTeamMemberAvailabilitiesTeamMembersRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpResponse<any>>;
  public updateManyTeamMemberAvailabilitiesTeamMembers(
    requestParameters?: HeadcountOverviewServiceUpdateManyTeamMemberAvailabilitiesTeamMembersRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<HttpEvent<any>>;
  public updateManyTeamMemberAvailabilitiesTeamMembers(
    requestParameters?: HeadcountOverviewServiceUpdateManyTeamMemberAvailabilitiesTeamMembersRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling updateManyTeamMemberAvailabilitiesTeamMembers.'
      );
    }
    const startDate = requestParameters?.startDate;
    if (startDate === null || startDate === undefined) {
      throw new Error(
        'Required parameter startDate was null or undefined when calling updateManyTeamMemberAvailabilitiesTeamMembers.'
      );
    }
    const endDate = requestParameters?.endDate;
    if (endDate === null || endDate === undefined) {
      throw new Error(
        'Required parameter endDate was null or undefined when calling updateManyTeamMemberAvailabilitiesTeamMembers.'
      );
    }
    const disableElevatedPermissions = requestParameters?.disableElevatedPermissions;
    const headcountOverviewDetailedTeamMembersUpdateTeamMemberAvailabilityModel =
      requestParameters?.headcountOverviewDetailedTeamMembersUpdateTeamMemberAvailabilityModel;

    let localVarQueryParameters = new HttpParams({ encoder: this.encoder });
    if (startDate !== undefined && startDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>startDate, 'StartDate');
    }
    if (endDate !== undefined && endDate !== null) {
      localVarQueryParameters = this.addToHttpParams(localVarQueryParameters, <any>endDate, 'EndDate');
    }
    if (disableElevatedPermissions !== undefined && disableElevatedPermissions !== null) {
      localVarQueryParameters = this.addToHttpParams(
        localVarQueryParameters,
        <any>disableElevatedPermissions,
        'disableElevatedPermissions'
      );
    }

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = [];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/team-members/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/availabilities`;
    return this.httpClient.request<any>('patch', `${this.configuration.basePath}${localVarPath}`, {
      context: localVarHttpContext,
      body: headcountOverviewDetailedTeamMembersUpdateTeamMemberAvailabilityModel,
      params: localVarQueryParameters,
      responseType: <any>responseType_,
      withCredentials: this.configuration.withCredentials,
      headers: localVarHeaders,
      observe: observe,
      transferCache: localVarTransferCache,
      reportProgress: reportProgress
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updatePositionRequestFinancialDataOverviewPositionRequest(
    requestParameters?: HeadcountOverviewServiceUpdatePositionRequestFinancialDataOverviewPositionRequestRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HeadcountApprovalPositionRequestsPositionRequestModel>;
  public updatePositionRequestFinancialDataOverviewPositionRequest(
    requestParameters?: HeadcountOverviewServiceUpdatePositionRequestFinancialDataOverviewPositionRequestRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpResponse<HeadcountApprovalPositionRequestsPositionRequestModel>>;
  public updatePositionRequestFinancialDataOverviewPositionRequest(
    requestParameters?: HeadcountOverviewServiceUpdatePositionRequestFinancialDataOverviewPositionRequestRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<HttpEvent<HeadcountApprovalPositionRequestsPositionRequestModel>>;
  public updatePositionRequestFinancialDataOverviewPositionRequest(
    requestParameters?: HeadcountOverviewServiceUpdatePositionRequestFinancialDataOverviewPositionRequestRequestParams,
    observe: any = 'body',
    reportProgress: boolean = false,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: HttpContext;
      transferCache?: boolean;
    }
  ): Observable<any> {
    const id = requestParameters?.id;
    if (id === null || id === undefined) {
      throw new Error(
        'Required parameter id was null or undefined when calling updatePositionRequestFinancialDataOverviewPositionRequest.'
      );
    }
    const headcountOverviewPositionRequestsUpdatePositionRequestFinancialDataModel =
      requestParameters?.headcountOverviewPositionRequestsUpdatePositionRequestFinancialDataModel;

    let localVarHeaders = this.defaultHeaders;

    let localVarHttpHeaderAcceptSelected: string | undefined = options && options.httpHeaderAccept;
    if (localVarHttpHeaderAcceptSelected === undefined) {
      // to determine the Accept header
      const httpHeaderAccepts: string[] = ['text/plain', 'application/json', 'text/json'];
      localVarHttpHeaderAcceptSelected = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    }
    if (localVarHttpHeaderAcceptSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
    }

    let localVarHttpContext: HttpContext | undefined = options && options.context;
    if (localVarHttpContext === undefined) {
      localVarHttpContext = new HttpContext();
    }

    let localVarTransferCache: boolean | undefined = options && options.transferCache;
    if (localVarTransferCache === undefined) {
      localVarTransferCache = true;
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json'];
    const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected !== undefined) {
      localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
    }

    let responseType_: 'text' | 'json' | 'blob' = 'json';
    if (localVarHttpHeaderAcceptSelected) {
      if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
        responseType_ = 'text';
      } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
        responseType_ = 'json';
      } else {
        responseType_ = 'blob';
      }
    }

    let localVarPath = `/headcount/customer/overview/position-request/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`;
    return this.httpClient.request<HeadcountApprovalPositionRequestsPositionRequestModel>(
      'patch',
      `${this.configuration.basePath}${localVarPath}`,
      {
        context: localVarHttpContext,
        body: headcountOverviewPositionRequestsUpdatePositionRequestFinancialDataModel,
        responseType: <any>responseType_,
        withCredentials: this.configuration.withCredentials,
        headers: localVarHeaders,
        observe: observe,
        transferCache: localVarTransferCache,
        reportProgress: reportProgress
      }
    );
  }
}
